import { escapeHtml } from './validation.js';

/** Literal, case-insensitive matches with offsets into the original text. */
export function findTextMatches(text, query, {caseSensitive = false} = {}) {
  const term = String(query || '').trim();
  if (!term) return [];
  const regex = new RegExp(term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), caseSensitive ? 'gu' : 'giu');
  return [...String(text || '').matchAll(regex)].map(match => ({ start: match.index, end: match.index + match[0].length }));
}

export function highlightText(text, query, activeIndex = -1) {
  text = String(text || '');
  let offset = 0;
  let html = '';
  for (const [index, match] of findTextMatches(text, query).entries()) {
    html += escapeHtml(text.slice(offset, match.start)) + (index === activeIndex ? '<mark class="search-current-match">' : '<mark>') + escapeHtml(text.slice(match.start, match.end)) + '</mark>';
    offset = match.end;
  }
  return html + escapeHtml(text.slice(offset));
}

export function searchSnippet(text, query, radius = 58) {
  text = String(text || '').replace(/\s+/g, ' ');
  const match = findTextMatches(text, query)[0];
  const start = Math.max(0, (match?.start || 0) - radius);
  const end = Math.min(text.length, (match?.end || 0) + radius);
  return (start ? '…' : '') + text.slice(start, end) + (end < text.length ? '…' : '');
}
